
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clustering/create",
      function () {
        return require("private-next-pages/clustering/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clustering/create"])
      });
    }
  